import React from 'react'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import { Colors } from '@ringdna/common/src/constants/colors'
import RdnaMenu from '@ringdna/common/src/components/RdnaMenu'
import styled from 'styled-components'
import CaretFilledIcon from '@ringdna/common/src/assets/icons/svg/CaretFilled'

type Props = {
  onQuickAddClick: () => void
  onAddUsersClick: () => void
}

export default function AddUsersButton({ onQuickAddClick, onAddUsersClick }: Props) {
  return (
    <Group>
      <ButtonGroup variant="contained">
        <Button onClick={onAddUsersClick}>{'Add Users'}</Button>
        <StyledMenu options={[{ text: 'Quick Add' }]} onSelect={() => onQuickAddClick()}>
          <Button size="small" aria-haspopup="menu">
            <CaretFilledIcon color={Colors.WHITE} size={10} />
          </Button>
        </StyledMenu>
      </ButtonGroup>
    </Group>
  )
}

const Group = styled.div`
  display: inline-flex;
  [role='group'] {
    box-shadow: none;
  }
  .MuiButton-root {
    background-color: ${Colors.M50};
    border-color: ${props => props.theme.palette.background.main} !important;
  }
`

const StyledMenu = styled(RdnaMenu)`
  > div {
    height: 100%;
  }
  .rdna-menu-toggle {
    margin: 0;
    height: 100%;
    button {
      height: 100%;
    }
  }
`
